import { brdFormComponentOptions, BRD_FORM_COMPONENT } from "./brd-form.component";
import * as angular from "angular";

export default angular
    .module("board.web.admin.brdForm", [
    ])
    .component(BRD_FORM_COMPONENT, brdFormComponentOptions)
    .name;


// WEBPACK FOOTER //
// ./app/common/brd-form/brd-form.module.ts